var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLeftsideBarSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 55,
    viewBox: "0 0 25 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 26.0646C14.6198 28.1573 14.2259 30.2296 13.4607 32.1631C12.6954 34.0965 11.5737 35.8533 10.1597 37.3331C8.74563 38.8129 7.06693 39.9868 5.21939 40.7877C3.37186 41.5885 1.39169 42.0007 -0.608062 42.0007L-0.608061 26.0646H14.6198Z",
    fill: "#FFC556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6198 26.0648C14.6198 23.9721 14.2259 21.8998 13.4607 19.9663C12.6954 18.0329 11.5737 16.2761 10.1597 14.7963C8.74563 13.3165 7.06693 12.1426 5.21939 11.3417C3.37186 10.5409 1.39169 10.1287 -0.608062 10.1287L-0.608061 26.0648H14.6198Z",
    fill: "#8DD5AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1312 48.6913L9.53345 40.2089L5.74061 42.5382L12.1312 48.6913Z",
    fill: "#FFC556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05699 51.7636L4.74286 43.054L0.300492 43.3315L3.05699 51.7636Z",
    fill: "#FFC556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9433 42.5371L13.5119 35.5228L10.7888 39.0437L18.9433 42.5371Z",
    fill: "#FFC556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2803 35.0116L15.8738 30.1286L14.4344 34.3404L23.2803 35.0116Z",
    fill: "#FFC556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1283 17.3861L14.3415 18.6076L16.0408 22.7215L23.1283 17.3861Z",
    fill: "#8DD5AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.775 9.71153L10.9499 13.891L13.9648 17.1655L18.775 9.71153Z",
    fill: "#8DD5AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8838 3.37196L5.78136 9.81091L9.67679 11.9643L11.8838 3.37196Z",
    fill: "#8DD5AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06157 0.3471L0.0778245 8.70156L4.51105 9.09917L3.06157 0.3471Z",
    fill: "#8DD5AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLeftsideBarSun);
export default __webpack_public_path__ + "static/media/AdminLeftsideBarSun.3ad5289c32f2bbeff646d0ca3e46dd6c.svg";
export { ForwardRef as ReactComponent };